<template>
  <v-card class="pegasus-dashboard">
    <v-progress-linear
      v-if="loading.page || loading.claim"
      indeterminate
      color="primary"
      class="mb-4"
    ></v-progress-linear>

    <template>
      <section class="pegasus-hero">
        <div class="hero-copy">
          <div class="hero-eyebrow">PEGASUS</div>
          <h2 class="hero-title">Dashboard Pegasus</h2>
          <p class="hero-subtitle">
            Dashboard ini digunakan sebagai sarana pemantauan kinerja integrasi
            Host-to-Host antara PT Pegadaian dan PT Asuransi Takaful Umum.
          </p>
        </div>
        <div class="hero-highlight">
          <div class="highlight-label">Total Deklarasi</div>
          <div class="highlight-value">{{ totalCount }}</div>
          <div class="highlight-meta">Last update: {{ lastUpdatedLabel }}</div>
          <div class="highlight-grid">
            <div class="mini-card">
              <div class="mini-label">Total Premi</div>
              <div class="mini-value">{{ formatMoney(totalPremi) }}</div>
            </div>
            <div class="mini-card">
              <div class="mini-label">Total TSI</div>
              <div class="mini-value">{{ formatMoney(totalTSI) }}</div>
            </div>
          </div>
        </div>
      </section>

      <section class="filter-command-bar">
        <div class="filter-command-info">
          <span>Data Deklarasi</span>
          <small>{{ totalCount }} data ditemukan</small>
        </div>
        <div class="filter-command-actions">
          <v-btn
            class="command-btn command-btn--icon"
            icon
            :loading="loading.page"
            aria-label="Refresh data"
            @click="FetchData"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-menu
            v-model="menus.filters"
            :close-on-content-click="false"
            offset-y
            left
            transition="slide-y-transition"
            content-class="pegasus-filter-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="command-btn command-btn--filter"
                depressed
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left>mdi-filter-outline</v-icon>
                Filter
                <span v-if="activeFilterCount" class="filter-count">
                  {{ activeFilterCount }}
                </span>
              </v-btn>
            </template>
      <section class="filter-dock">
        <div class="filter-header">
          <div>
            <div class="filter-title">Filter Data</div>
            <div class="filter-subtitle">
              Sesuaikan data yang ingin ditampilkan.
            </div>
          </div>
          <v-btn icon small aria-label="Tutup filter" @click="menus.filters = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="filter-grid">
          <div class="filter-row filter-row-actions">
            <v-text-field
              v-model="search"
              class="filter-input"
              dense
              filled
              hide-details
              label="Cari deklarasi, kontrak, nasabah"
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
            <v-select
              v-model="filters.jenisAsuransi"
              class="filter-input"
              dense
              filled
              hide-details
              :items="jenisAsuransiOptions"
              item-text="text"
              item-value="value"
              label="Jenis asuransi"
            ></v-select>
            <v-autocomplete
              v-model="filters.branch"
              class="filter-input"
              dense
              filled
              hide-details
              clearable
              auto-select-first
              :items="branchOptions"
              :filter="FilterBranchOption"
              item-text="text"
              item-value="value"
              label="Branch"
              placeholder="Ketik nama atau kode branch"
              prepend-inner-icon="mdi-magnify"
              no-data-text="Branch tidak ditemukan"
              @change="NormalizeBranchFilter"
            ></v-autocomplete>
            <v-select
              v-model="filters.status"
              class="filter-input"
              dense
              filled
              hide-details
              :items="statusOptions"
              item-text="text"
              item-value="value"
              label="Status invoice"
            ></v-select>
          </div>
          <div class="filter-row">
            <v-menu
              v-model="menus.dateStart"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filters.dateStart"
                  v-bind="attrs"
                  v-on="on"
                  class="filter-input"
                  dense
                  filled
                  hide-details
                  clearable
                  label="Tanggal mulai"
                  prepend-inner-icon="mdi-calendar-start"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.dateStart"
                @input="menus.dateStart = false"
              ></v-date-picker>
            </v-menu>
            <v-menu
              v-model="menus.dateEnd"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filters.dateEnd"
                  v-bind="attrs"
                  v-on="on"
                  class="filter-input"
                  dense
                  filled
                  hide-details
                  clearable
                  label="Tanggal akhir"
                  prepend-inner-icon="mdi-calendar-end"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.dateEnd"
                @input="menus.dateEnd = false"
              ></v-date-picker>
            </v-menu>
            <div class="filter-actions">
              <v-btn
                class="apply-btn"
                depressed
                :loading="loading.page"
                @click="ApplyFilters"
              >
                Terapkan Filter
              </v-btn>
              <v-btn class="filter-reset" text @click="ResetFilters">
                Reset
              </v-btn>
            </div>
          </div>
        </div>
      </section>
          </v-menu>
          <v-btn
            class="command-btn command-btn--export"
            depressed
            :loading="loading.export"
            :disabled="!filteredItems.length || loading.export"
            @click="ExportExcel"
          >
            <v-icon left>mdi-download-outline</v-icon>
            Export
            <v-icon right small>mdi-chevron-down</v-icon>
          </v-btn>
        </div>
      </section>

      <v-row class="stats-row">
        <v-col
          v-for="(card, index) in statCards"
          :key="card.label"
          cols="12"
          sm="6"
          md="4"
        >
          <div class="stat-card" :style="{ '--i': index }">
            <div class="stat-label">{{ card.label }}</div>
            <div class="stat-value">{{ card.value }}</div>
            <div class="stat-note">{{ card.note }}</div>
          </div>
        </v-col>
      </v-row>

      <v-row class="insight-row">
        <v-col cols="12" md="7">
          <div class="insight-card dist-card">
            <div class="insight-head">
              <div>
                <div class="insight-title">Distribusi Jenis Asuransi</div>
                <div class="insight-sub">
                  Komposisi berdasarkan jumlah deklarasi.
                </div>
              </div>
              <span class="insight-badge">Comparison</span>
            </div>
            <div class="dist-content">
              <div class="dist-chart">
                <svg class="pie-chart" viewBox="0 0 120 120" aria-hidden="true">
                  <g v-if="jenisPieSlices.length" transform="rotate(-90 60 60)">
                    <circle
                      v-for="slice in jenisPieSlices"
                      :key="slice.label"
                      class="pie-slice"
                      :class="{
                        'is-active': isJenisActive(slice),
                        'is-dim': isJenisDim(slice),
                        'is-clickable': slice.code
                      }"
                      cx="60"
                      cy="60"
                      :r="slice.radius"
                      :stroke="slice.color"
                      :stroke-dasharray="slice.dashArray"
                      :stroke-dashoffset="slice.dashOffset"
                      @click="ToggleJenisFilter(slice.code)"
                    ></circle>
                  </g>
                  <circle
                    v-else
                    class="pie-empty"
                    cx="60"
                    cy="60"
                    r="42"
                  ></circle>
                </svg>
                <div class="pie-center">
                  <div class="pie-total">{{ jenisDistributionTotal }}</div>
                  <div class="pie-label">Deklarasi</div>
                </div>
              </div>
              <div class="dist-legend">
                <div v-if="!jenisDistribution.length" class="legend-empty">
                  Belum ada data
                </div>
                <template v-else>
                  <div
                    v-for="group in jenisDistribution"
                    :key="group.label"
                    class="legend-row"
                    :class="{
                      'is-active': isJenisActive(group),
                      'is-dim': isJenisDim(group),
                      'is-clickable': group.code
                    }"
                    role="button"
                    tabindex="0"
                    :aria-pressed="isJenisActive(group)"
                    @click="ToggleJenisFilter(group.code)"
                    @keydown.enter.prevent="ToggleJenisFilter(group.code)"
                    @keydown.space.prevent="ToggleJenisFilter(group.code)"
                  >
                    <div class="legend-left">
                      <span
                        class="legend-dot"
                        :style="{ backgroundColor: group.color }"
                      ></span>
                      <span class="legend-text">{{ group.label }}</span>
                    </div>
                    <div class="legend-right">
                      {{ group.count }} ({{ group.percent }}%)
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="5">
          <div class="insight-card branch-card">
            <div class="insight-head">
              <div>
                <div class="insight-title">Top Branch</div>
                <div class="insight-sub">
                  Berdasarkan total premi tertinggi.
                </div>
              </div>
              <span class="insight-badge">Leaderboard</span>
            </div>
            <div
              v-for="(branch, index) in topBranches"
              :key="branch.branch"
              class="branch-row"
            >
              <div class="branch-rank">{{ index + 1 }}</div>
              <div class="branch-info">
                <div class="branch-name">{{ branch.branch }}</div>
                <div class="branch-meta">{{ branch.count }} deklarasi</div>
              </div>
              <div class="branch-value">
                {{ formatMoney(branch.totalPremi) }}
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </template>

    <section class="pegasus-tabs">
      <div class="workspace-nav">
        <v-tabs
          v-model="tabPegasus"
          background-color="transparent"
          color="primary"
        >
          <v-tab href="#tab-deklarasi">
            <v-icon left small>mdi-file-document-outline</v-icon>
            Deklarasi
            <span class="tab-count">{{ filteredItems.length }}</span>
          </v-tab>
          <v-tab href="#tab-claim" @click="EnsureClaimData">
            <v-icon left small>mdi-shield-check-outline</v-icon>
            Klaim
            <span class="tab-count">{{ filteredClaimItems.length }}</span>
          </v-tab>
        </v-tabs>
        <div class="workspace-actions">
          <v-btn
            v-if="tabPegasus === 'tab-deklarasi'"
            class="export-btn workspace-export-btn"
            depressed
            :loading="loading.export"
            :disabled="!filteredItems.length || loading.export"
            @click="ExportExcel"
          >
            <v-icon left>mdi-file-excel-outline</v-icon>
            Export Excel
          </v-btn>
        </div>
      </div>

      <v-tabs-items v-model="tabPegasus" class="workspace-content">
        <v-tab-item value="tab-deklarasi">
          <div class="table-header">
            <div class="table-title">Daftar Deklarasi</div>
          </div>
          <v-card class="table-shell" elevation="0">
            <v-data-table
              :headers="headers"
              :items="filteredItems"
              :items-per-page="10"
              item-key="noDeklarasi"
              class="pegasus-table"
              :loading="loading.page"
              loading-text="Loading data..."
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right'
              }"
            >
              <template v-slot:item.noDeklarasi="{ item }">
                <div class="cell-stack">
                  <div class="cell-main">{{ safeText(item.noDeklarasi) }}</div>
                  <div class="cell-sub">
                    Kontrak: {{ safeText(item.noKontrak) }}
                  </div>
                </div>
              </template>
              <template v-slot:item.namaNasabah="{ item }">
                <div class="cell-stack">
                  <div class="cell-main">{{ safeText(item.namaNasabah) }}</div>
                  <div class="cell-sub">
                    ID: {{ safeText(item.noIdentitas) }}
                  </div>
                </div>
              </template>
              <template v-slot:item.Produk="{ item }">
                <div class="cell-stack">
                  <div class="cell-main">{{ safeText(item.Produk) }}</div>
                  <div class="cell-sub">
                    {{ jenisAsuransiLabel(item.jenisAsuransi) }}
                  </div>
                </div>
              </template>
              <template v-slot:item.tglKredit="{ item }">
                <div class="cell-stack">
                  <div class="cell-main">{{ formatDate(item.tglKredit) }}</div>
                  <div class="cell-sub">
                    s/d {{ formatDate(item.tglJatuhTempo) }}
                  </div>
                </div>
              </template>
              <template v-slot:item.totalPremi="{ item }">
                <div class="cell-stack">
                  <div class="cell-main">
                    {{ formatMoney(item.totalPremi) }}
                  </div>
                  <div class="cell-sub">
                    Rate {{ formatRate(item.ratePremi) }}
                  </div>
                </div>
              </template>
              <template v-slot:item.nomorInvoice="{ item }">
                <div class="cell-stack">
                  <v-chip
                    class="status-chip"
                    :class="invoiceStatusClass(item)"
                    small
                  >
                    {{ invoiceStatus(item) }}
                  </v-chip>
                  <div v-if="item.nomorInvoice" class="cell-sub">
                    {{ item.nomorInvoice }}
                  </div>
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      class="detail-btn"
                      text
                      v-bind="attrs"
                      v-on="on"
                    >
                      Aksi
                      <v-icon right small>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item @click="OpenDetail(item)">
                      <v-list-item-title>Detail</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      :disabled="
                        !item.noKontrak || invoiceStatus(item) !== 'Paid'
                      "
                      @click="OpenCertificate(item)"
                    >
                      <v-list-item-title>Cetak sertifikat</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:no-data>
                <div class="empty-state">
                  <div class="empty-title">Tidak ada data</div>
                  <div class="empty-sub">
                    Coba ubah filter atau refresh data.
                  </div>
                  <v-btn class="hero-btn" depressed @click="FetchData">
                    Refresh data
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>

        <v-tab-item value="tab-claim">
          <div class="table-header">
            <div class="table-title">Daftar Klaim Pegasus</div>
            <div class="table-actions">
              <v-text-field
                v-model="claimSearch"
                class="filter-input table-search"
                dense
                outlined
                hide-details
                label="Cari klaim"
                prepend-inner-icon="mdi-magnify"
              ></v-text-field>
              <v-btn
                class="export-btn"
                height="40"
                depressed
                :loading="loading.claim"
                :disabled="loading.claim"
                @click="FetchClaimPegasus"
              >
                <v-icon left>mdi-refresh</v-icon>
                Refresh
              </v-btn>
            </div>
          </div>
          <v-card class="table-shell" elevation="0">
            <v-data-table
              :headers="claimHeaders"
              :items="filteredClaimItems"
              :items-per-page="10"
              item-key="claim_row"
              class="pegasus-table"
              :loading="loading.claim"
              loading-text="Loading data..."
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right'
              }"
            >
              <template v-slot:item.claim_branchclientname="{ item }">
                <div class="cell-stack">
                  <div class="cell-main">
                    {{ safeText(item.claim_branchclientname) }}
                  </div>
                  <div class="cell-sub">
                    {{ safeText(item.claim_branchclientarea) }} -
                    {{ safeText(item.claim_branchclientkanwil) }}
                  </div>
                </div>
              </template>
              <template v-slot:item.claim_clientproductname="{ item }">
                <div class="cell-stack">
                  <div class="cell-main">
                    {{ safeText(item.claim_clientproductname) }}
                  </div>
                  <div class="cell-sub">
                    ID: {{ safeText(item.claim_clientproductid) }}
                  </div>
                </div>
              </template>
              <template v-slot:item.claim_amount="{ item }">
                <div class="cell-main">
                  {{ formatMoney(item.claim_amount) }}
                </div>
              </template>
              <template v-slot:no-data>
                <div class="empty-state">
                  <div class="empty-title">Tidak ada data klaim</div>
                  <div class="empty-sub">Coba refresh data klaim.</div>
                  <v-btn class="hero-btn" depressed @click="FetchClaimPegasus">
                    Refresh data
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </section>

    <v-dialog v-model="dialog.detail" max-width="920">
      <v-card class="detail-card">
        <v-card-title class="detail-title-row">
          <div>
            <div class="detail-title">
              {{ safeText(selected.noDeklarasi) }}
            </div>
            <div class="detail-subtitle">
              Kontrak {{ safeText(selected.noKontrak) }} - Branch
              {{ safeText(selected.branchDesc || selected.branch) }}
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-chip class="status-chip" :class="invoiceStatusClass(selected)">
            {{ invoiceStatus(selected) }}
          </v-chip>
        </v-card-title>
        <v-card-text>
          <div class="detail-grid">
            <div class="detail-block">
              <div class="detail-label">Nasabah</div>
              <div class="detail-value">
                {{ safeText(selected.namaNasabah) }}
              </div>
              <div class="detail-subvalue">
                {{ safeText(selected.noIdentitas) }}
              </div>
            </div>
            <div class="detail-block">
              <div class="detail-label">Jenis Asuransi</div>
              <div class="detail-value">
                {{ jenisAsuransiLabel(selected.jenisAsuransi) }}
              </div>
              <div class="detail-subvalue">
                Kode {{ safeText(selected.kodeAsuransi) }}
              </div>
            </div>
            <div class="detail-block">
              <div class="detail-label">Periode Kredit</div>
              <div class="detail-value">
                {{ formatDate(selected.tglKredit) }}
              </div>
              <div class="detail-subvalue">
                s/d {{ formatDate(selected.tglJatuhTempo) }}
              </div>
            </div>
            <div class="detail-block">
              <div class="detail-label">Premi</div>
              <div class="detail-value">
                {{ formatMoney(selected.totalPremi) }}
              </div>
              <div class="detail-subvalue">
                TSI {{ formatMoney(selected.TSI) }}
              </div>
            </div>
            <div class="detail-block">
              <div class="detail-label">Invoice</div>
              <div class="detail-value">
                {{ safeText(selected.nomorInvoice) }}
              </div>
              <div class="detail-subvalue">
                {{ safeText(selected.namaPayor) }}
              </div>
            </div>
            <div class="detail-block">
              <div class="detail-label">Alamat</div>
              <div class="detail-value">{{ safeText(selected.alamat) }}</div>
              <div class="detail-subvalue">
                {{ safeText(selected.kodePos) }}
              </div>
            </div>
          </div>

          <div v-if="selected.jenisAsuransi === '01'" class="detail-group">
            <div class="detail-group-title">Detail Gadai</div>
            <div class="detail-grid">
              <div class="detail-block">
                <div class="detail-label">History Transaksi</div>
                <div class="detail-value">
                  {{ safeText(selected.historyTransaksi) }}
                </div>
              </div>
              <div class="detail-block">
                <div class="detail-label">Rubrik</div>
                <div class="detail-value">{{ safeText(selected.rubrik) }}</div>
              </div>
              <div class="detail-block">
                <div class="detail-label">Klaster</div>
                <div class="detail-value">{{ safeText(selected.klaster) }}</div>
              </div>
              <div class="detail-block">
                <div class="detail-label">Golongan</div>
                <div class="detail-value">
                  {{ safeText(selected.golongan) }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="selected.jenisAsuransi === '02'" class="detail-group">
            <div class="detail-group-title">Detail Kendaraan</div>
            <div class="detail-grid">
              <div class="detail-block">
                <div class="detail-label">Tipe Kendaraan</div>
                <div class="detail-value">
                  {{ safeText(selected.tipeKendaraan) }}
                </div>
              </div>
              <div class="detail-block">
                <div class="detail-label">Nomor Polisi</div>
                <div class="detail-value">
                  {{ safeText(selected.nomorPolisi) }}
                </div>
              </div>
              <div class="detail-block">
                <div class="detail-label">Nomor Rangka</div>
                <div class="detail-value">
                  {{ safeText(selected.nomorRangka) }}
                </div>
              </div>
              <div class="detail-block">
                <div class="detail-label">Nomor Mesin</div>
                <div class="detail-value">
                  {{ safeText(selected.nomorMesin) }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="selected.jenisAsuransi === '03'" class="detail-group">
            <div class="detail-group-title">Detail Properti</div>
            <div class="detail-grid">
              <div class="detail-block">
                <div class="detail-label">Okupansi</div>
                <div class="detail-value">
                  {{ safeText(selected.okupansi) }}
                </div>
              </div>
              <div class="detail-block">
                <div class="detail-label">Kelas Konstruksi</div>
                <div class="detail-value">
                  {{ safeText(selected.kelasKonstruksi) }}
                </div>
              </div>
              <div class="detail-block">
                <div class="detail-label">Alamat Properti</div>
                <div class="detail-value">
                  {{ safeText(selected.alamatProperti) }}
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog.detail = false">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: "AppPgdPegasus",
  data: () => ({
    loading: {
      page: false,
      export: false,
      claim: false
    },
    tabPegasus: "tab-deklarasi",
    items: [],
    claimItems: [],
    search: "",
    claimSearch: "",
    lastUpdated: null,
    claimLoaded: false,
    filters: {
      jenisAsuransi: "all",
      branch: "all",
      status: "all",
      dateStart: "",
      dateEnd: ""
    },
    dialog: {
      detail: false
    },
    selected: {},
    menus: {
      filters: false,
      dateStart: false,
      dateEnd: false
    }
  }),
  computed: {
    activeFilterCount() {
      return [
        this.search,
        this.filters.jenisAsuransi !== "all",
        this.filters.branch !== "all",
        this.filters.status !== "all",
        this.filters.dateStart,
        this.filters.dateEnd
      ].filter(Boolean).length;
    },
    headers() {
      return [
        { text: "Deklarasi / Kontrak", value: "noDeklarasi" },
        { text: "Nasabah", value: "namaNasabah" },
        { text: "Produk", value: "Produk" },
        { text: "Periode", value: "tglKredit" },
        { text: "Premi", value: "totalPremi", align: "end" },
        { text: "Invoice", value: "nomorInvoice" },
        { text: "", value: "actions", sortable: false }
      ];
    },
    claimHeaders() {
      return [
        { text: "Claim Row", value: "claim_row" },
        { text: "Branch", value: "claim_branchclientname" },
        { text: "Produk", value: "claim_clientproductname" },
        { text: "Kategori", value: "claim_category" },
        { text: "Amount", value: "claim_amount", align: "end" }
      ];
    },
    filteredItems() {
      const searchValue = this.search.toLowerCase().trim();
      return this.items.filter(item => {
        const matchSearch =
          !searchValue ||
          [
            item.noDeklarasi,
            item.noKontrak,
            item.namaNasabah,
            item.kodeProduk,
            item.branch,
            item.branchDesc,
            item.nomorInvoice
          ]
            .filter(Boolean)
            .some(value =>
              String(value)
                .toLowerCase()
                .includes(searchValue)
            );
        const matchJenis =
          this.filters.jenisAsuransi === "all" ||
          item.jenisAsuransi === this.filters.jenisAsuransi;
        const matchBranch =
          this.filters.branch === "all" ||
          item.branch === this.filters.branch ||
          item.branchDesc === this.filters.branch;
        const matchStatus =
          this.filters.status === "all" ||
          this.invoiceStatus(item) === this.filters.status;

        return matchSearch && matchJenis && matchBranch && matchStatus;
      });
    },
    filteredClaimItems() {
      const searchValue = this.claimSearch.toLowerCase().trim();
      return this.claimItems.filter(item => {
        if (!searchValue) {
          return true;
        }
        const fields = [
          item.claim_row,
          item.claim_branchclientid,
          item.claim_branchclientname,
          item.claim_branchclientarea,
          item.claim_branchclientkanwil,
          item.claim_clientproductid,
          item.claim_clientproductname,
          item.claim_category
        ];
        return fields.filter(Boolean).some(value =>
          String(value)
            .toLowerCase()
            .includes(searchValue)
        );
      });
    },
    totalCount() {
      return this.filteredItems.length;
    },
    jenisDistributionTotal() {
      return this.jenisDistribution.reduce(
        (sum, group) => sum + group.count,
        0
      );
    },
    totalPremi() {
      return this.filteredItems.reduce(
        (total, item) => total + (Number(item.totalPremi) || 0),
        0
      );
    },
    totalTSI() {
      return this.filteredItems.reduce(
        (total, item) => total + (Number(item.TSI) || 0),
        0
      );
    },
    paidCount() {
      return this.filteredItems.filter(
        item => this.invoiceStatus(item) === "Paid"
      ).length;
    },
    pendingCount() {
      return this.filteredItems.filter(
        item => this.invoiceStatus(item) === "Pending"
      ).length;
    },
    statCards() {
      return [
        {
          label: "Invoice Paid",
          value: this.paidCount,
          note: "status terbayar"
        },
        {
          label: "Invoice Pending",
          value: this.pendingCount,
          note: "menunggu pembayaran"
        },
        {
          label: "Total Record",
          value: this.totalCount,
          note: "data terfilter"
        }
      ];
    },
    jenisAsuransiOptions() {
      const options = [
        { text: "Semua jenis", value: "all" },
        { text: "Gadai", value: "01" },
        { text: "Kendaraan", value: "02" },
        { text: "Properti", value: "03" }
      ];
      return options;
    },
    branchOptions() {
      const branchMap = {};
      this.items.forEach(item => {
        const value = item.branch || item.branchDesc;
        if (!value) {
          return;
        }
        if (!branchMap[value]) {
          branchMap[value] = {
            code: item.branch || "",
            name: item.branchDesc || item.branch || ""
          };
        }
      });
      return [{ text: "Semua branch", value: "all" }].concat(
        Object.keys(branchMap)
          .sort()
          .map(value => {
            const branch = branchMap[value];
            return {
              text:
                branch.code && branch.name !== branch.code
                  ? `${branch.code} - ${branch.name}`
                  : branch.name,
              value: value
            };
          })
      );
    },
    statusOptions() {
      return [
        { text: "Semua status", value: "all" },
        { text: "Paid", value: "Paid" },
        { text: "Invoiced", value: "Invoiced" },
        { text: "Pending", value: "Pending" }
      ];
    },

    jenisDistribution() {
      const totals = {};
      this.filteredItems.forEach(item => {
        const code = item.jenisAsuransi;
        if (!code) {
          return;
        }
        if (!totals[code]) {
          totals[code] = {
            code: code,
            label: this.jenisAsuransiLabel(code),
            count: 0
          };
        }
        totals[code].count += 1;
      });
      const entries = Object.values(totals);
      const total = entries.reduce((sum, entry) => sum + entry.count, 0);
      const palette = ["#1c6a62", "#d9ae5a", "#0f3d3a", "#9cb4ad", "#b27c2d"];
      return entries
        .sort((a, b) => b.count - a.count)
        .map((entry, index) => ({
          code: entry.code,
          label: entry.label,
          count: entry.count,
          fraction: total ? entry.count / total : 0,
          percent: total ? ((entry.count / total) * 100).toFixed(1) : "0.0",
          color: palette[index % palette.length]
        }));
    },
    jenisPieSlices() {
      const radius = 42;
      const circumference = 2 * Math.PI * radius;
      let offset = 0;
      return this.jenisDistribution.map(group => {
        const dash = group.fraction * circumference;
        const slice = {
          code: group.code,
          label: group.label,
          radius: radius,
          color: group.color,
          dashArray: `${dash} ${circumference}`,
          dashOffset: -offset
        };
        offset += group.fraction * circumference;
        return slice;
      });
    },
    topBranches() {
      const totals = {};
      this.filteredItems.forEach(item => {
        const branch = item.branchDesc || item.branch || "Unknown";
        if (!totals[branch]) {
          totals[branch] = { count: 0, totalPremi: 0 };
        }
        totals[branch].count += 1;
        totals[branch].totalPremi += Number(item.totalPremi) || 0;
      });
      return Object.keys(totals)
        .map(branch => ({
          branch: branch,
          count: totals[branch].count,
          totalPremi: totals[branch].totalPremi
        }))
        .sort((a, b) => b.totalPremi - a.totalPremi)
        .slice(0, 4);
    },
    lastUpdatedLabel() {
      if (!this.lastUpdated) {
        return "-";
      }
      return this.lastUpdated.toLocaleString("id-ID", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    }
  },
  created() {
    this.FetchData();
    this.FetchClaimPegasus();
  },
  methods: {
    ShowDeclaration() {
      this.tabPegasus = "tab-deklarasi";
    },
    NormalizeBranchFilter(value) {
      if (!value) this.filters.branch = "all";
    },
    FilterBranchOption(item, queryText) {
      const keyword = String(queryText || "")
        .trim()
        .toLowerCase();
      if (!keyword) return true;
      return [item.text, item.value]
        .filter(Boolean)
        .some(value =>
          String(value)
            .toLowerCase()
            .includes(keyword)
        );
    },
    ApplyFilters() {
      this.menus.filters = false;
      this.FetchData();
    },
    FetchData() {
      this.loading.page = true;
      const formData = new FormData();
      if (this.filters.dateStart) {
        formData.append("fastflow_cdate_start", this.filters.dateStart);
      }
      if (this.filters.dateEnd) {
        formData.append("fastflow_cdate_end", this.filters.dateEnd);
      }
      this.$axios
        .post(
          this.$functions.SafeURL("apiListDashboardPegasus", ""),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          const feedback = response.data || [];
          if (feedback.length > 0 && feedback[0].feedback === "Y") {
            this.items = feedback;
          } else if (feedback.length > 0 && feedback[0].feedback !== "Y") {
            this.items = [];
          } else {
            this.items = [];
          }
          this.lastUpdated = new Date();
          this.loading.page = false;
        })
        .catch(() => {
          this.items = [];
          this.loading.page = false;
        });
    },
    EnsureClaimData() {
      if (this.claimLoaded) {
        return;
      }
      this.FetchClaimPegasus();
    },
    FetchClaimPegasus() {
      if (this.loading.claim) {
        return;
      }
      this.loading.claim = true;
      const formData = new FormData();
      this.$axios
        .post(this.$functions.SafeURL("apiListClaimPegasus", ""), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          const feedback = response.data || [];
          if (feedback.length > 0 && feedback[0].feedback === "Y") {
            this.claimItems = feedback;
          } else if (feedback.length > 0 && feedback[0].feedback !== "Y") {
            this.claimItems = [];
          } else {
            this.claimItems = [];
          }
          this.claimLoaded = true;
          this.loading.claim = false;
        })
        .catch(() => {
          this.claimItems = [];
          this.claimLoaded = true;
          this.loading.claim = false;
        });
    },
    ExportExcel() {
      if (!this.filteredItems.length || this.loading.export) {
        return;
      }
      this.loading.export = true;
      try {
        const headers = [
          "NO DEKLARASI",
          "NO KONTRAK",
          "KODE ASURANSI",
          "JENIS ASURANSI",
          "KODE PRODUK",
          "BRANCH",
          "BRANCH DESC",
          "NAMA NASABAH",
          "ALAMAT",
          "KODE POS",
          "NO IDENTITAS",
          "TIPE NASABAH",
          "TGL LAHIR",
          "TEMPAT LAHIR",
          "JENIS KELAMIN",
          "KEWARGANEGARAAN",
          "STATUS PERKAWINAN",
          "NAMA IBU KANDUNG",
          "PEKERJAAN",
          "PENGHASILAN RATA-RATA",
          "TGL KREDIT",
          "TGL JATUH TEMPO",
          "TENOR",
          "TSI",
          "RATE PREMI",
          "TOTAL PREMI",
          "SEWA MODAL",
          "TUJUAN KREDIT",
          "TIPE PENGAJUAN",
          "NOMOR INVOICE",
          "TGL INVOICE",
          "TGL JATUH TEMPO INVOICE",
          "NAMA PAYOR",
          "STATUS INVOICE",
          "HISTORY TRANSAKSI",
          "RUBRIK",
          "KLASTER",
          "GOLONGAN",
          "JENIS TRANSAKSI",
          "RASIO TAKSIR",
          "JENIS PAYOR",
          "TIPE KENDARAAN",
          "TIPE RISIKO",
          "WILAYAH",
          "NOMOR POLISI",
          "NOMOR RANGKA",
          "NOMOR MESIN",
          "MERK KENDARAAN",
          "MODEL KENDARAAN",
          "OKUPANSI",
          "KELAS KONSTRUKSI",
          "ALAMAT PROPERTI"
        ];
        const escapeHtml = value => {
          if (value === null || value === undefined) {
            return "";
          }
          return String(value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
        };
        const normalizeDate = value => {
          if (!value) {
            return "";
          }
          const text = String(value);
          return text.split("T")[0].split(" ")[0];
        };
        const formatNumber = value => {
          if (value === null || value === undefined || value === "") {
            return "";
          }
          return this.$functions.FormatNumber(Number(value) || 0, 0);
        };
        const formatRate = value => {
          if (value === null || value === undefined || value === "") {
            return "";
          }
          return this.$functions.FormatNumber(Number(value) || 0, 2);
        };
        const excelText = value => {
          if (value === null || value === undefined || value === "") {
            return "";
          }
          const raw = String(value).trim();
          const digitsOnly = /^[0-9]+$/.test(raw);
          const hasLeadingZero = raw.length > 1 && raw[0] === "0";
          if (digitsOnly && (raw.length >= 12 || hasLeadingZero)) {
            return `="${raw}"`;
          }
          return raw;
        };
        const rows = this.filteredItems.map(item => [
          excelText(item.noDeklarasi),
          excelText(item.noKontrak),
          this.safeText(item.kodeAsuransi),
          this.jenisAsuransiLabel(item.jenisAsuransi),
          this.safeText(item.kodeProduk),
          this.safeText(item.branch),
          this.safeText(item.branchDesc || item.branch),
          this.safeText(item.namaNasabah),
          this.safeText(item.alamat),
          excelText(item.kodePos),
          excelText(item.noIdentitas),
          excelText(item.tipeNasabah),
          normalizeDate(item.tglLahir),
          this.safeText(item.tempatLahir),
          this.safeText(item.jenisKelamin),
          this.safeText(item.kewarganegaraan),
          this.safeText(item.statusPerkawinan),
          this.safeText(item.namaIbuKandung),
          this.safeText(item.pekerjaan),
          this.safeText(item.penghasilanRataRata),
          normalizeDate(item.tglKredit),
          normalizeDate(item.tglJatuhTempo),
          formatNumber(item.tenor),
          formatNumber(item.TSI),
          formatRate(item.ratePremi),
          formatNumber(item.totalPremi),
          this.safeText(item.sewaModal),
          excelText(item.tujuanKredit),
          excelText(item.tipePengajuan),
          excelText(item.nomorInvoice),
          normalizeDate(item.tglInvoice),
          normalizeDate(item.tglJatuhTempoInvoice),
          this.safeText(item.namaPayor),
          this.invoiceStatus(item),
          this.safeText(item.historyTransaksi),
          this.safeText(item.rubrik),
          this.safeText(item.klaster),
          this.safeText(item.golongan),
          this.safeText(item.jenisTransaksi),
          this.safeText(item.rasioTaksir),
          this.safeText(item.jenisPayor),
          this.safeText(item.tipeKendaraan),
          this.safeText(item.tipeRisiko),
          this.safeText(item.wilayah),
          this.safeText(item.nomorPolisi),
          this.safeText(item.nomorRangka),
          this.safeText(item.nomorMesin),
          this.safeText(item.merkKendaraan),
          this.safeText(item.modelKendaraan),
          this.safeText(item.okupansi),
          this.safeText(item.kelasKonstruksi),
          this.safeText(item.alamatProperti)
        ]);
        const colgroup = `<colgroup>
          <col style="width:220px;">
          <col style="width:220px;">
          <col style="width:140px;">
          <col style="width:140px;">
          <col style="width:140px;">
          <col style="width:120px;">
          <col style="width:180px;">
          <col style="width:200px;">
          <col style="width:260px;">
          <col style="width:110px;">
          <col style="width:200px;">
          <col style="width:130px;">
          <col style="width:130px;">
          <col style="width:130px;">
          <col style="width:140px;">
          <col style="width:140px;">
          <col style="width:150px;">
          <col style="width:200px;">
          <col style="width:160px;">
          <col style="width:200px;">
          <col style="width:130px;">
          <col style="width:140px;">
          <col style="width:110px;">
          <col style="width:140px;">
          <col style="width:120px;">
          <col style="width:140px;">
          <col style="width:140px;">
          <col style="width:140px;">
          <col style="width:160px;">
          <col style="width:160px;">
          <col style="width:140px;">
          <col style="width:170px;">
          <col style="width:160px;">
          <col style="width:160px;">
          <col style="width:160px;">
          <col style="width:150px;">
          <col style="width:150px;">
          <col style="width:150px;">
          <col style="width:150px;">
          <col style="width:140px;">
          <col style="width:140px;">
          <col style="width:140px;">
          <col style="width:140px;">
          <col style="width:140px;">
          <col style="width:150px;">
          <col style="width:150px;">
          <col style="width:150px;">
          <col style="width:150px;">
          <col style="width:150px;">
          <col style="width:150px;">
          <col style="width:180px;">
          <col style="width:200px;">
        </colgroup>`;
        const tableStyleAttr = 'style="border-collapse:collapse;width:100%;"';
        const headerBaseStyle =
          "background-color:#155852;color:#ffffff;font-weight:bold;border:1px solid #e0e0e0;padding:6px 10px;text-align:left;";
        const cellBaseStyle =
          "border:1px solid #e0e0e0;padding:6px 10px;text-align:left;";
        const tableHeader =
          "<tr>" +
          headers
            .map(
              title =>
                `<th style="${headerBaseStyle}">${escapeHtml(title)}</th>`
            )
            .join("") +
          "</tr>";
        const tableRows = rows
          .map(row => {
            return (
              "<tr>" +
              row
                .map(
                  col => `<td style="${cellBaseStyle}">${escapeHtml(col)}</td>`
                )
                .join("") +
              "</tr>"
            );
          })
          .join("");
        const table = `<table ${tableStyleAttr}>${colgroup}${tableHeader}${tableRows}</table>`;
        const blob = new Blob(["\ufeff" + table], {
          type: "application/vnd.ms-excel"
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        const today = this.$functions.Today
          ? this.$functions.Today()
          : new Date().toISOString().slice(0, 10);
        link.href = url;
        link.setAttribute(
          "download",
          `dashboard-pegasus-${today.replace(/\//g, "-")}.xls`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } finally {
        this.loading.export = false;
      }
    },
    ResetFilters() {
      this.filters.jenisAsuransi = "all";
      this.filters.branch = "all";
      this.filters.status = "all";
      this.filters.dateStart = "";
      this.filters.dateEnd = "";
      this.search = "";
    },
    CertificateUrl(item) {
      const noKontrak = item && item.noKontrak;
      if (!noKontrak) {
        return "";
      }
      const base = this.$functions.SSOURL().replace(/\/$/, "");
      return `${base}/modul/mod_documents/PEGADAIAN_SERTIFIKAT_PEGASUS.php?&fastflow_refid=${encodeURIComponent(
        noKontrak
      )}`;
    },
    OpenCertificate(item) {
      if (this.invoiceStatus(item) !== "Paid") {
        return;
      }
      const url = this.CertificateUrl(item);
      if (!url) {
        return;
      }
      window.open(url, "_blank");
    },
    ToggleJenisFilter(code) {
      if (!code) {
        return;
      }
      this.filters.jenisAsuransi =
        this.filters.jenisAsuransi === code ? "all" : code;
    },
    isJenisActive(group) {
      return (
        this.filters.jenisAsuransi !== "all" &&
        group.code === this.filters.jenisAsuransi
      );
    },
    isJenisDim(group) {
      return (
        this.filters.jenisAsuransi !== "all" &&
        group.code !== this.filters.jenisAsuransi
      );
    },
    OpenDetail(item) {
      this.selected = item || {};
      this.dialog.detail = true;
    },
    safeText(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      return value;
    },
    formatDate(value) {
      if (!value) {
        return "-";
      }
      const datePart = String(value)
        .split("T")[0]
        .split(" ")[0];
      return this.$functions.FormatDateIndo(datePart);
    },
    formatMoney(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      return `Rp ${this.$functions.FormatNumber(Number(value) || 0, 0)}`;
    },
    formatRate(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      return this.$functions.FormatNumber(Number(value) || 0, 2);
    },
    jenisAsuransiLabel(code) {
      if (code === "01") return "Gadai";
      if (code === "02") return "Kendaraan";
      if (code === "03") return "Properti";
      return code || "-";
    },
    invoiceStatus(item) {
      if (!item) {
        return "Pending";
      }
      if (item.namaPayor || item.tglInvoice) {
        return "Paid";
      }
      if (item.nomorInvoice) {
        return "Invoiced";
      }
      return "Pending";
    },
    invoiceStatusClass(item) {
      const status = this.invoiceStatus(item);
      if (status === "Paid") return "status-paid";
      if (status === "Invoiced") return "status-invoiced";
      return "status-pending";
    }
  }
};
</script>

<style scoped>
.pegasus-dashboard {
  --pegasus-ink: #273449;
  --pegasus-muted: #6f7d91;
  --pegasus-gold: #53c7f3;
  --pegasus-teal: #287cf0;
  --pegasus-ice: #e9eef5;
  --pegasus-sand: #f4f7fb;
  font-family: "Segoe UI", Tahoma, sans-serif;
  background: #e9eef5;
  border: 0;
  border-radius: 16px;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.pegasus-dashboard::before {
  content: "";
  position: absolute;
  width: 320px;
  height: 320px;
  top: -160px;
  right: -120px;
  border-radius: 50%;
  background: #e6ebf2;
  box-shadow: inset 10px 10px 24px #cfd6e0, inset -10px -10px 24px #ffffff;
  opacity: 0.6;
}

.pegasus-dashboard::after {
  display: none;
}

.pegasus-hero {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  padding: 28px 30px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 22px;
  background: #e9eef5;
  color: var(--pegasus-ink);
  box-shadow: 14px 14px 30px #cbd3de, -14px -14px 30px #ffffff;
  animation: fade-in 0.6s ease-out;
}

.hero-copy {
  flex: 1 1 320px;
  min-width: 260px;
}

.hero-eyebrow {
  font-size: 0.75rem;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
  color: #287cf0;
  font-weight: 700;
}

.hero-title {
  font-family: inherit;
  font-size: clamp(1.65rem, 2.2vw, 2.25rem);
  font-weight: 700;
  margin: 8px 0 8px;
}

.hero-subtitle {
  color: var(--pegasus-muted);
  max-width: 520px;
}

.hero-actions {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 12px;
}

.hero-btn {
  color: #0f3d3a !important;
  background: var(--pegasus-gold) !important;
  border-radius: 14px;
  font-weight: 600;
}

.hero-highlight {
  flex: 1 1 260px;
  min-width: 240px;
  background: #e9eef5;
  border: 1px solid rgba(255, 255, 255, 0.66);
  border-radius: 18px;
  padding: 20px;
  box-shadow: inset 7px 7px 15px #d0d7e1, inset -7px -7px 15px #ffffff;
}

.highlight-label {
  font-size: 0.9rem;
  color: var(--pegasus-muted);
}

.highlight-value {
  font-size: 2.2rem;
  font-weight: 600;
  margin: 4px 0;
}

.highlight-meta {
  font-size: 0.85rem;
  color: var(--pegasus-muted);
}

.highlight-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin-top: 16px;
}

.mini-card {
  background: #e9eef5;
  border: 1px solid rgba(255, 255, 255, 0.62);
  border-radius: 12px;
  padding: 12px;
  box-shadow: 5px 5px 11px #cbd3de, -5px -5px 11px #ffffff;
}

.mini-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08rem;
  color: var(--pegasus-muted);
}

.mini-value {
  margin-top: 4px;
  font-weight: 600;
}

.stats-row {
  margin-top: 18px;
}

.stat-card {
  background: #e9eef5;
  border-radius: 14px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-top: 3px solid #53c7f3;
  box-shadow: 8px 8px 18px #cbd3de, -8px -8px 18px #ffffff;
  animation: rise 0.6s ease-out;
  animation-delay: calc(var(--i) * 90ms);
  animation-fill-mode: both;
}

.stat-label {
  font-size: 0.8rem;
  color: var(--pegasus-muted);
  text-transform: uppercase;
  letter-spacing: 0.08rem;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--pegasus-ink);
  margin-top: 6px;
}

.stat-note {
  font-size: 0.8rem;
  color: var(--pegasus-muted);
  margin-top: 4px;
}

.insight-row {
  margin-top: 10px;
}

.insight-card {
  background: #e9eef5;
  border-radius: 14px;
  padding: 18px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  box-shadow: 8px 8px 18px #cbd3de, -8px -8px 18px #ffffff;
}

.insight-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}

.insight-badge {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.18rem;
  padding: 6px 10px;
  border-radius: 999px;
  background: #e9eef5;
  color: #287cf0;
  box-shadow: inset 3px 3px 7px #d0d7e1, inset -3px -3px 7px #ffffff;
  font-weight: 600;
}

.dist-card {
  position: relative;
  overflow: hidden;
}

.dist-card::after {
  content: "";
  position: absolute;
  width: 180px;
  height: 180px;
  right: -90px;
  top: -70px;
  background: radial-gradient(circle, rgba(217, 174, 90, 0.2), transparent 70%);
}

.dist-content {
  display: grid;
  grid-template-columns: minmax(200px, 240px) 1fr;
  gap: 18px;
  align-items: center;
}

.dist-chart {
  position: relative;
  width: 220px;
  height: 220px;
  margin: 0 auto;
}

.pie-chart {
  width: 100%;
  height: 100%;
}

.pie-slice {
  fill: none;
  stroke-width: 18;
  transition: opacity 0.2s ease, stroke-width 0.2s ease;
}

.pie-slice.is-clickable {
  cursor: pointer;
}

.pie-slice.is-dim {
  opacity: 0.35;
}

.pie-slice.is-active {
  stroke-width: 22;
}

.pie-slice.is-clickable:hover {
  opacity: 0.9;
}

.pie-empty {
  fill: none;
  stroke: #edf1ef;
  stroke-width: 18;
}

.pie-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.pie-total {
  font-size: 1.6rem;
  font-weight: 600;
  color: var(--pegasus-ink);
}

.pie-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  color: var(--pegasus-muted);
}

.dist-legend {
  display: grid;
  gap: 10px;
}

.legend-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid rgba(21, 37, 42, 0.08);
}

.legend-row:last-child {
  border-bottom: none;
}

.legend-row.is-clickable {
  cursor: pointer;
}

.legend-row.is-clickable:hover {
  background: rgba(21, 88, 82, 0.06);
}

.legend-row.is-active {
  background: rgba(21, 88, 82, 0.12);
  border-radius: 10px;
  padding: 6px 8px;
}

.legend-row.is-dim {
  opacity: 0.6;
}

.legend-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
}

.legend-text {
  font-size: 0.85rem;
  color: var(--pegasus-ink);
  font-weight: 600;
}

.legend-right {
  font-size: 0.8rem;
  color: var(--pegasus-muted);
}

.legend-empty {
  font-size: 0.85rem;
  color: var(--pegasus-muted);
}

.insight-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--pegasus-ink);
}

.insight-sub {
  font-size: 0.85rem;
  color: var(--pegasus-muted);
  margin-bottom: 12px;
}

.dist-row {
  display: grid;
  grid-template-columns: 1fr 2fr auto;
  gap: 10px;
  align-items: center;
  margin-bottom: 12px;
}

.dist-label {
  font-size: 0.85rem;
  color: var(--pegasus-ink);
  display: flex;
  align-items: center;
  gap: 8px;
}

.dist-rank {
  font-size: 0.7rem;
  font-weight: 700;
  background: rgba(217, 174, 90, 0.2);
  color: #a87824;
  padding: 2px 6px;
  border-radius: 8px;
}

.dist-bar {
  height: 8px;
  background: #edf1ef;
  border-radius: 999px;
  overflow: hidden;
  position: relative;
}

.dist-bar span {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, #1c6a62, #d9ae5a);
  border-radius: 999px;
}

.dist-glow {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(20%, -50%);
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(217, 174, 90, 0.4), transparent 70%);
  pointer-events: none;
}

.dist-value {
  text-align: right;
}

.dist-count {
  font-weight: 600;
  color: var(--pegasus-ink);
}

.dist-percent {
  font-size: 0.75rem;
  color: var(--pegasus-muted);
}

.branch-card {
  position: relative;
  overflow: hidden;
}

.branch-card::after {
  content: "";
  position: absolute;
  width: 160px;
  height: 160px;
  right: -90px;
  bottom: -70px;
  background: radial-gradient(circle, rgba(21, 88, 82, 0.18), transparent 70%);
}

.branch-row {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(21, 37, 42, 0.08);
  align-items: center;
}

.branch-row:last-child {
  border-bottom: none;
}

.branch-rank {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  font-weight: 700;
  color: #1c6a62;
  background: rgba(21, 88, 82, 0.12);
}

.branch-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.branch-name {
  font-weight: 600;
  color: var(--pegasus-ink);
}

.branch-meta {
  font-size: 0.8rem;
  color: var(--pegasus-muted);
}

.branch-value {
  font-weight: 600;
  color: var(--pegasus-teal);
}

.filter-command-bar {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
  padding: 13px 16px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 16px;
  background: #e9eef5;
  box-shadow: 7px 7px 16px #cbd3de, -7px -7px 16px #ffffff;
}

.filter-command-info {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.filter-command-info span {
  color: var(--pegasus-ink);
  font-size: 0.9rem;
  font-weight: 700;
}

.filter-command-info small {
  margin-top: 2px;
  color: var(--pegasus-muted);
  font-size: 0.75rem;
}

.filter-command-actions {
  display: flex;
  align-items: center;
  gap: 9px;
}

.command-btn {
  height: 42px !important;
  padding: 0 16px !important;
  border: 1px solid rgba(255, 255, 255, 0.78);
  border-radius: 10px !important;
  background: #e9eef5 !important;
  color: #354566 !important;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  box-shadow: 4px 4px 9px #c8d0db, -4px -4px 9px #ffffff;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
}

.command-btn--icon {
  width: 42px !important;
  min-width: 42px !important;
  padding: 0 !important;
}

.command-btn--filter {
  background: linear-gradient(135deg, #334a91, #22356f) !important;
  color: #ffffff !important;
  box-shadow: 5px 5px 12px #bcc6d4, -4px -4px 10px #ffffff;
}

.command-btn:not(.v-btn--disabled):hover {
  transform: translateY(-1px);
  box-shadow: 6px 6px 13px #c4ccd7, -5px -5px 11px #ffffff;
}

.filter-count {
  display: inline-grid;
  width: 20px;
  height: 20px;
  margin-left: 8px;
  place-items: center;
  border-radius: 50%;
  background: #53c7f3;
  color: #152550;
  font-size: 11px;
  font-weight: 800;
}

.filter-dock {
  width: min(420px, calc(100vw - 32px));
  max-height: 76vh;
  margin: 10px 0;
  padding: 20px;
  border-radius: 14px;
  background: #e9eef5;
  border: 1px solid rgba(255, 255, 255, 0.72);
  box-shadow: 12px 12px 28px rgba(70, 82, 102, 0.24),
    -8px -8px 20px rgba(255, 255, 255, 0.9);
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
}

.filter-dock::after {
  display: none;
}

.filter-header {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(113, 127, 148, 0.16);
}

.filter-title {
  font-family: inherit;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--pegasus-ink);
}

.filter-subtitle {
  font-size: 0.85rem;
  color: var(--pegasus-muted);
  margin-top: 4px;
}

.filter-meta {
  font-size: 0.85rem;
  color: var(--pegasus-muted);
}

.filter-grid {
  position: relative;
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filter-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.filter-row-actions {
  grid-template-columns: 1fr;
}

.filter-input {
  min-width: 180px;
}

.filter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: stretch;
  grid-column: auto;
  margin-top: 4px;
  padding-top: 14px;
  border-top: 1px solid rgba(113, 127, 148, 0.16);
}

.filter-actions .apply-btn {
  flex: 1 1 auto;
}

.filter-reset {
  color: #43527a !important;
  font-weight: 600;
  text-transform: none;
}

.apply-btn {
  height: 42px !important;
  padding: 0 20px !important;
  background: linear-gradient(135deg, #3997ff, #1671e8) !important;
  color: #ffffff !important;
  border-radius: 10px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  box-shadow: 6px 6px 13px #bdc7d5, -5px -5px 12px #ffffff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.apply-btn:hover {
  transform: translateY(-1px);
  box-shadow: 8px 8px 16px #bdc7d5, -6px -6px 14px #ffffff;
}

.export-btn {
  height: 40px;
  border-radius: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #287cf0 !important;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: #e9eef5 !important;
  box-shadow: 5px 5px 11px #c7cfda, -5px -5px 11px #ffffff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.export-btn:hover {
  transform: translateY(-1px);
  box-shadow: 7px 7px 14px #c7cfda, -6px -6px 13px #ffffff;
}

.table-shell {
  margin-top: 0;
  background: transparent;
}

.pegasus-tabs {
  margin-top: 18px;
  padding: 0;
  overflow: visible;
  border: 1px solid #dfe5ee;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(24, 36, 76, 0.08);
}

.workspace-nav {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 68px;
  padding: 0 14px 0 4px;
  border-bottom: 1px solid #e2e7f0;
  background: #f7f9fc;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 6px 16px rgba(24, 36, 76, 0.08);
}

.pegasus-tabs ::v-deep .v-tabs {
  flex: 1 1 auto;
  min-width: 0;
  background: #f7f9fc;
  border: 0;
  border-radius: 0;
  overflow: hidden;
  box-shadow: none;
}

.pegasus-tabs ::v-deep .v-tab {
  min-width: 160px;
  height: 44px;
  margin: 7px 4px;
  padding: 0 16px;
  border-radius: 10px;
  text-transform: none;
  font-weight: 600;
  color: #59647e;
  letter-spacing: 0;
}

.pegasus-tabs ::v-deep .v-tab--active {
  background: linear-gradient(135deg, #2e427f, #1d2d60);
  color: #ffffff !important;
  box-shadow: inset 0 -3px 0 #53c7f3, 0 6px 14px rgba(29, 45, 96, 0.2);
}

.pegasus-tabs ::v-deep .v-tab .v-icon {
  color: #73809b;
}

.pegasus-tabs ::v-deep .v-tab--active .v-icon {
  color: #75d8ff;
}

.tab-count {
  display: inline-grid;
  min-width: 24px;
  height: 20px;
  margin-left: 9px;
  padding: 0 6px;
  place-items: center;
  border-radius: 999px;
  background: #e5eaf2;
  color: #5d6981;
  font-size: 10px;
  font-weight: 700;
}

.pegasus-tabs ::v-deep .v-tab--active .tab-count {
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
}

.pegasus-tabs ::v-deep .v-tabs-slider {
  display: none;
}

.workspace-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
}

.workspace-export-btn {
  height: 42px !important;
  padding: 0 17px !important;
  color: #ffffff !important;
  border: 0;
  background: #202f68 !important;
  box-shadow: 0 7px 16px rgba(32, 47, 104, 0.2);
}

.workspace-content {
  background: #ffffff !important;
}

.table-header {
  margin-top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  min-height: 68px;
  padding: 13px 16px;
  border: 0;
  border-bottom: 1px solid #e7ebf2;
  border-radius: 0;
  background: #ffffff;
}

.table-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
}

.table-search {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 260px;
}

.table-actions .export-btn {
  flex: 0 0 auto;
}

.table-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #25345f;
}

.pegasus-table {
  margin-bottom: 0;
  background: #ffffff;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
}

.pegasus-table ::v-deep .v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #a8afba #f0f2f5;
}

.pegasus-table ::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.pegasus-table ::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #f0f2f5;
}

.pegasus-table ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  border: 2px solid #f0f2f5;
  border-radius: 999px;
  background: #9299a5;
}

.pegasus-table ::v-deep thead tr {
  background: #e1e8f1;
}

.pegasus-table ::v-deep thead th {
  height: 50px;
  padding: 0 18px;
  border-bottom: 1px solid #d8e0eb !important;
  background: #edf3f8;
  color: #25345f !important;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
}

.pegasus-table ::v-deep tbody td {
  height: 50px;
  padding: 0 18px;
  border-bottom: 1px solid #edf0f5 !important;
  color: #34405f;
  font-size: 13px;
  transition: background-color 0.2s ease;
}

.pegasus-table ::v-deep tbody tr:hover td {
  background: #f8faff !important;
}

.pegasus-table ::v-deep .v-data-footer {
  min-height: 64px;
  border-top: 0;
  color: #5e687f;
}

.pegasus-table ::v-deep .v-data-footer .v-btn {
  color: #25345f;
}

.table-header .export-btn {
  color: #ffffff !important;
  border: 0;
  background: #202f68 !important;
  box-shadow: 0 7px 16px rgba(32, 47, 104, 0.2);
}

.table-header .export-btn:hover {
  background: #182653 !important;
  box-shadow: 0 9px 20px rgba(32, 47, 104, 0.28);
}

.table-header ::v-deep .table-search .v-input__slot {
  background: #ffffff !important;
  border-color: #d5dbea;
  box-shadow: none;
}

.cell-stack {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cell-main {
  font-weight: 600;
  color: var(--pegasus-ink);
}

.cell-sub {
  font-size: 0.78rem;
  color: var(--pegasus-muted);
}

.status-chip {
  font-weight: 600;
  border-radius: 999px;
}

.status-paid {
  background: rgba(21, 122, 86, 0.16) !important;
  color: #137255 !important;
}

.status-invoiced {
  background: rgba(217, 174, 90, 0.2) !important;
  color: #a87824 !important;
}

.status-pending {
  background: rgba(203, 88, 38, 0.16) !important;
  color: #a34b22 !important;
}

.detail-btn {
  color: var(--pegasus-teal) !important;
  font-weight: 600;
}

.empty-state {
  padding: 40px;
  text-align: center;
}

.empty-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--pegasus-ink);
}

.empty-sub {
  font-size: 0.9rem;
  color: var(--pegasus-muted);
  margin: 6px 0 16px;
}

.detail-card {
  border-radius: 18px;
}

.detail-title-row {
  border-bottom: 1px solid rgba(21, 37, 42, 0.08);
}

.detail-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--pegasus-ink);
}

.detail-subtitle {
  font-size: 0.85rem;
  color: var(--pegasus-muted);
  margin-top: 4px;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 14px;
  margin-bottom: 16px;
}

.detail-block {
  background: #f9faf9;
  border-radius: 12px;
  padding: 12px;
  border: 1px solid rgba(21, 37, 42, 0.08);
}

.detail-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08rem;
  color: var(--pegasus-muted);
}

.detail-value {
  margin-top: 6px;
  font-weight: 600;
  color: var(--pegasus-ink);
}

.detail-subvalue {
  font-size: 0.8rem;
  color: var(--pegasus-muted);
  margin-top: 4px;
}

.detail-group {
  margin-top: 12px;
}

.detail-group-title {
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--pegasus-ink);
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 960px) {
  .pegasus-dashboard {
    padding: 18px;
  }
  .pegasus-hero {
    padding: 18px;
  }
  .highlight-grid {
    grid-template-columns: 1fr;
  }
  .dist-content {
    grid-template-columns: 1fr;
  }
  .dist-chart {
    width: 200px;
    height: 200px;
  }
  .filter-row {
    grid-template-columns: 1fr;
  }
  .filter-actions {
    grid-column: auto;
    justify-content: flex-end;
  }
  .table-actions {
    width: 100%;
  }
  .table-search {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 100%;
  }
}

@media (max-width: 600px) {
  .filter-command-bar {
    align-items: flex-start;
    flex-direction: column;
  }
  .filter-command-actions {
    width: 100%;
  }
  .command-btn--filter,
  .command-btn--export {
    flex: 1 1 0;
  }
  .pegasus-tabs {
    padding: 0 8px;
  }

  .workspace-nav {
    flex-wrap: wrap;
    gap: 8px;
    padding: 6px 8px 10px;
  }

  .workspace-nav > .v-tabs {
    flex-basis: 100%;
  }

  .workspace-actions,
  .workspace-export-btn {
    width: 100%;
  }

  .table-actions {
    justify-content: flex-end;
  }
}

::v-deep .filter-input .v-input__control {
  border-radius: 10px;
}

::v-deep .filter-input .v-input__slot {
  min-height: 48px;
  background: #e9eef5 !important;
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: 10px !important;
  box-shadow: inset 4px 4px 9px #cfd6e0, inset -4px -4px 9px #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

::v-deep .filter-input .v-input__slot::before,
::v-deep .filter-input .v-input__slot::after {
  display: none !important;
  border: 0 !important;
}

::v-deep .filter-input.v-input--is-focused .v-input__slot {
  border-color: #53c7f3;
  box-shadow: inset 3px 3px 7px #cfd6e0, inset -3px -3px 7px #ffffff,
    0 0 0 3px rgba(83, 199, 243, 0.16);
}

/* Clean dashboard theme */
.pegasus-dashboard {
  padding: 24px;
  border: 1px solid #e4e9f1;
  border-radius: 20px;
  background: #f6f8fb;
  box-shadow: none;
}

.pegasus-dashboard::before {
  display: none;
}

.pegasus-hero {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(320px, 0.75fr);
  gap: 32px;
  align-items: center;
  padding: 30px 32px;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(35, 52, 82, 0.06);
}

.hero-title {
  margin: 7px 0 10px;
  color: #17243b;
  font-size: clamp(1.7rem, 2vw, 2.15rem);
  line-height: 1.18;
}

.hero-subtitle {
  max-width: 650px;
  margin: 0;
  color: #64748b;
  line-height: 1.65;
}

.hero-highlight {
  min-width: 0;
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 15px;
  background: #f8fafc;
  box-shadow: none;
}

.highlight-value {
  margin: 3px 0;
  color: #17243b;
  font-size: 2rem;
  font-weight: 700;
}

.highlight-grid {
  gap: 10px;
  margin-top: 15px;
}

.mini-card {
  padding: 13px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 11px;
  background: #ffffff;
  box-shadow: none;
}

.filter-command-bar {
  margin-top: 16px;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(35, 52, 82, 0.05);
}

.command-btn,
.export-btn {
  border-color: #dbe3ee !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.command-btn--filter {
  border-color: transparent !important;
  background: #253b7b !important;
  box-shadow: 0 5px 12px rgba(37, 59, 123, 0.18) !important;
}

.stats-row {
  margin-top: 10px;
}

.stat-card {
  min-height: 126px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-top: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 5px 16px rgba(35, 52, 82, 0.05);
}

.stat-card::before {
  content: "";
  display: block;
  width: 34px;
  height: 3px;
  margin-bottom: 15px;
  border-radius: 999px;
  background: #2c79e8;
}

.stat-value {
  margin-top: 5px;
  font-size: 1.65rem;
  font-weight: 700;
}

.insight-row {
  margin-top: 2px;
}

.insight-card {
  height: 100%;
  padding: 22px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 5px 16px rgba(35, 52, 82, 0.05);
}

.dist-card::after,
.branch-card::after {
  display: none;
}

.insight-badge {
  padding: 5px 9px;
  border: 1px solid #dbeafe;
  background: #eff6ff;
  color: #2563eb;
  box-shadow: none;
  letter-spacing: 0.1rem;
}

.dist-content {
  grid-template-columns: minmax(170px, 200px) 1fr;
  gap: 28px;
}

.dist-chart {
  width: 180px;
  height: 180px;
}

.branch-row {
  padding: 13px 0;
  border-color: #edf1f6;
}

.branch-rank {
  border-radius: 10px;
  background: #eef6f6;
  color: #15736d;
}

@media (max-width: 960px) {
  .pegasus-hero {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .pegasus-dashboard {
    padding: 12px;
  }

  .pegasus-hero {
    padding: 22px 18px;
  }

  .filter-command-bar {
    align-items: flex-start;
    flex-direction: column;
  }

  .filter-command-actions {
    width: 100%;
  }

  .dist-content {
    grid-template-columns: 1fr;
  }
}

/* Unified glassmorphism layout */
.pegasus-dashboard {
  --glass-surface: rgba(255, 255, 255, 0.68);
  --glass-surface-strong: rgba(255, 255, 255, 0.82);
  --glass-border: rgba(255, 255, 255, 0.88);
  --glass-shadow: 0 14px 38px rgba(37, 55, 89, 0.1);
  padding: 24px;
  overflow: visible;
  border: 1px solid rgba(214, 225, 239, 0.9);
  background:
    radial-gradient(circle at 8% 4%, rgba(87, 190, 240, 0.2), transparent 30%),
    radial-gradient(circle at 94% 16%, rgba(73, 112, 210, 0.16), transparent 28%),
    linear-gradient(145deg, #edf4fa 0%, #f6f8fc 48%, #eaf1f8 100%);
}

.pegasus-dashboard > * {
  position: relative;
  z-index: 1;
}

.pegasus-hero,
.filter-command-bar,
.stat-card,
.insight-card {
  border: 1px solid var(--glass-border);
  background: var(--glass-surface);
  box-shadow: var(--glass-shadow);
  backdrop-filter: blur(18px) saturate(145%);
  -webkit-backdrop-filter: blur(18px) saturate(145%);
}

.pegasus-hero {
  grid-template-columns: minmax(0, 3fr) minmax(360px, 2fr);
  gap: 36px;
  min-height: 230px;
  padding: 32px;
  border-radius: 20px;
}

.hero-copy,
.hero-highlight {
  width: 100%;
}

.hero-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
}

.hero-highlight {
  display: flex;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
  padding: 22px;
  border: 1px solid rgba(255, 255, 255, 0.92);
  border-radius: 16px;
  background: rgba(248, 251, 255, 0.62);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9),
    0 8px 22px rgba(41, 59, 93, 0.06);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.highlight-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.mini-card {
  min-width: 0;
  border-color: rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.62);
  box-shadow: 0 5px 14px rgba(40, 58, 89, 0.05);
}

.mini-value {
  overflow-wrap: anywhere;
}

.filter-command-bar {
  min-height: 70px;
  margin-top: 18px;
  padding: 13px 16px;
  border-radius: 16px;
}

.stats-row,
.insight-row {
  margin-right: -8px;
  margin-left: -8px;
}

.stats-row > .col,
.insight-row > .col {
  display: flex;
  padding: 8px;
}

.stat-card {
  width: 100%;
  min-height: 132px;
  padding: 20px;
  border-radius: 16px;
}

.insight-row {
  align-items: stretch;
  margin-top: 0;
}

.insight-card {
  width: 100%;
  min-height: 330px;
  border-radius: 16px;
}

.dist-content {
  grid-template-columns: minmax(180px, 0.8fr) minmax(220px, 1.2fr);
  min-height: 240px;
}

.branch-card {
  display: flex;
  flex-direction: column;
}

.branch-row {
  grid-template-columns: 36px minmax(0, 1fr) minmax(120px, auto);
}

.branch-name,
.branch-value {
  overflow-wrap: anywhere;
}

.command-btn:not(.command-btn--filter),
.export-btn {
  border-color: rgba(255, 255, 255, 0.92) !important;
  background: rgba(255, 255, 255, 0.64) !important;
  box-shadow: 0 6px 16px rgba(39, 57, 89, 0.08) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

@media (max-width: 1100px) {
  .pegasus-hero {
    grid-template-columns: minmax(0, 1fr) minmax(320px, 0.85fr);
    gap: 22px;
  }
}

@media (max-width: 900px) {
  .pegasus-hero {
    grid-template-columns: 1fr;
  }

  .insight-card {
    min-height: auto;
  }
}

@media (max-width: 600px) {
  .pegasus-dashboard {
    padding: 10px;
    border-radius: 14px;
  }

  .pegasus-hero {
    min-height: 0;
    gap: 20px;
    padding: 20px 16px;
  }

  .highlight-grid,
  .dist-content {
    grid-template-columns: 1fr;
  }

  .filter-command-actions {
    display: grid;
    grid-template-columns: 42px 1fr 1fr;
  }

  .branch-row {
    grid-template-columns: 34px minmax(0, 1fr);
  }

  .branch-value {
    grid-column: 2;
  }
}

.workspace-export-btn {
  min-width: 178px !important;
  height: 46px !important;
  padding: 0 20px !important;
  border: 1px solid rgba(255, 255, 255, 0.52) !important;
  border-radius: 13px !important;
  background: linear-gradient(
    135deg,
    rgba(43, 66, 139, 0.94),
    rgba(27, 45, 101, 0.9)
  ) !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  letter-spacing: 0.025em !important;
  box-shadow: 0 10px 24px rgba(28, 45, 101, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.22) !important;
  backdrop-filter: blur(14px) saturate(140%);
  -webkit-backdrop-filter: blur(14px) saturate(140%);
  transition: transform 0.2s ease, box-shadow 0.2s ease,
    filter 0.2s ease !important;
}

.workspace-export-btn ::v-deep .v-icon {
  color: #75d8ff !important;
}

.workspace-export-btn:not(.v-btn--disabled):hover {
  filter: brightness(1.08);
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(28, 45, 101, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.28) !important;
}

.workspace-export-btn.v-btn--disabled {
  border-color: rgba(180, 191, 207, 0.45) !important;
  background: rgba(211, 219, 230, 0.62) !important;
  color: #8793a7 !important;
  box-shadow: none !important;
}

.workspace-export-btn.v-btn--disabled ::v-deep .v-icon {
  color: #97a3b5 !important;
}
</style>
